import useParagonToken from './Paragon/useParagonToken';

const useExternalTokens = () => {
	useParagonToken();
};

export default useExternalTokens;
